import { render, staticRenderFns } from "./ChangeInform.vue?vue&type=template&id=4a629bf4&scoped=true&"
import script from "./ChangeInform.vue?vue&type=script&lang=js&"
export * from "./ChangeInform.vue?vue&type=script&lang=js&"
import style0 from "./ChangeInform.vue?vue&type=style&index=0&id=4a629bf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a629bf4",
  null
  
)

export default component.exports